import { CONVERSATIONS_LIST_FILTER } from 'Constants/localstorage';
import { CONVERSATIONS_FILTER_OPTIONS, type ConversationsFilterType } from 'Modules/conversation/conversations-list/store/index.types';

const DEFAULT_FILTER: ConversationsFilterType = 'all';

const buildKey = (userId: number) => `user-${userId}:${CONVERSATIONS_LIST_FILTER}`;

export const getStoredConversationsFilter = (userId: number): ConversationsFilterType => {
  try {
    const stored = localStorage.getItem(buildKey(userId));

    if (stored === null) {
      return DEFAULT_FILTER;
    }

    if (CONVERSATIONS_FILTER_OPTIONS.includes(stored as ConversationsFilterType)) {
      return stored as ConversationsFilterType;
    }

    // Return default for invalid values
    return DEFAULT_FILTER;
  } catch (error) {
    console.error('Failed to get filter from localStorage:', error);
    return DEFAULT_FILTER;
  }
};

export const setStoredConversationsFilter = (userId: number, value: ConversationsFilterType): void => {
  try {
    localStorage.setItem(buildKey(userId), value);
  } catch (error) {
    console.error('Failed to save filter to localStorage:', error);
  }
};